'use strict';

// Function to return text color with best contrast by aRBG value
function ARGBTextColorFilter() {
  return function(color) {
    var R = ((color & 0x00ff0000) >> 16) / 255;
    var B = ((color & 0x0000ff00) >> 8) / 255;
    var G = (color & 0x000000ff) / 255;

    var L = (0.299 * R + 0.587 * G + 0.114 * B);

    if (L >= 0.5) {
      return '#000000';
    }

    return '#ffffff';
  };
}

angular.module('dokiv')
  .filter('ARGBTextColorFilter', ARGBTextColorFilter);



//////////////////
// WEBPACK FOOTER
// ./scripts/app/ARGBTextColorFilter.js
// module id = 234
// module chunks = 0